import { Configurables } from './Configurables';

export enum ConfigurableStatus {
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not_available',
  COMING_SOON = 'coming_soon',
}

export enum PricingType {
  REGULAR = 'regular',
  FREE_FOREVER = 'free_forever',
  FREE_DURING_ALPHA = 'free_during_alpha',
}

export interface FeaturePricing {
  pricing: {
    price: {
      amount: {
        $numberDecimal: string
      }
    }
  }
}

export interface Plan {
  _id: string
  name: string
  code: string
  current: boolean
  configurables: Configurables[]
  features: {refId: string, status: ConfigurableStatus, pricing: FeaturePricing}[]
  regions: {refId: string, status: ConfigurableStatus}[]
  sizes: {refId: string, status: ConfigurableStatus}[]
}
